<template>
  <div id="app" class="main-app">
    <router-view :key="$route.fullPath"></router-view>
    <!-- <vue-progress-bar></vue-progress-bar> -->
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { mapMutations, mapGetters } from 'vuex';

export default {
	name: 'App',
	beforeMount(){
		this.loadMe()
	},
	computed: {
		...mapGetters(['isAuthenticated','loggedUser'])
	},
	methods:{
		...mapMutations(['logout']),
		loadMe(){
			// console.log('loadMe', this.isAuthenticated)
			if( this.isAuthenticated){
				this.$apollo.query({
					query: gql`query {
						me {
							id
							name
							email
						}
					}`,
					fetchPolicy: 'no-cache',
				})
				.then((data) => {
					// console.log('main LoadMe then', data)
					// this.updateLogged(data.data.meMedic);
				})
				.catch(() => {
					// console.log('main LoadMe catch', data)
					this.$router.push('/logout')
				});
			}else{
				// console.log('main NOT authenticated')
				this.$router.push('/logout')
			}
		},
	}

}
</script>
